import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import { Trip } from '@/types';
import TripCard from './TripCard';
import { useI18n } from '@/hooks/useI18n';

interface TripSectionProps {
    title: string;
    trips: Trip[];
    emptyMessage: string;
    onSelectTrip: (tripId: string) => void;
    onDuplicateTrip?: (trip: Trip) => void;
    onToggleSignUp?: (trip: Trip) => void;
}

const TripSection: React.FC<TripSectionProps> = ({
    title,
    trips,
    emptyMessage,
    onSelectTrip,
    onDuplicateTrip,
    onToggleSignUp
}) => {
    const { t } = useI18n();

    if (trips.length === 0) {
        return (
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'grey.800' }}>
                    {title}
                </Typography>
                <Card sx={{ textAlign: 'center', py: 4, backgroundColor: 'grey.100', boxShadow: 1 }}>
                    <CardContent>
                        <Typography variant="h6" component="h3" sx={{ fontWeight: 'medium', color: 'grey.600' }} gutterBottom>
                            {emptyMessage}
                        </Typography>
                    </CardContent>
                </Card>
            </Box>
        );
    }

    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'grey.800' }}>
                {title}
            </Typography>
            <Grid container spacing={3}>
                {trips.map((trip) => (
                    <Grid size={{ xs: 12, md: 6, lg: 4 }} key={trip.id}>
                        <TripCard
                            trip={trip}
                            onSelectTrip={onSelectTrip}
                            onDuplicateTrip={onDuplicateTrip}
                            onToggleSignUp={onToggleSignUp}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default TripSection;